var _circle, _circle2, _circle3, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCircle1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.7333,
    stroke: "black",
    strokeWidth: 0.533333
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.6667,
    cy: 24.0002,
    r: 18.4,
    stroke: "black",
    strokeWidth: 0.533333
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.6667,
    cy: 24.0002,
    r: 14.4,
    stroke: "black",
    strokeWidth: 0.533333
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7333 24.0002C15.7333 26.8936 14.8534 29.5028 13.4435 31.3826C12.0337 33.2624 10.1064 34.4002 8 34.4002C5.89361 34.4002 3.96631 33.2624 2.55648 31.3826C1.14659 29.5028 0.266667 26.8936 0.266667 24.0002C0.266667 21.1068 1.14659 18.4975 2.55648 16.6177C3.96631 14.7379 5.89362 13.6002 8 13.6002C10.1064 13.6002 12.0337 14.7379 13.4435 16.6177C14.8534 18.4975 15.7333 21.1068 15.7333 24.0002Z",
    stroke: "black",
    strokeWidth: 0.533333
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle1);
export default __webpack_public_path__ + "static/media/circle-1.e2eb1dbd04329f647641207ba79f3920.svg";
export { ForwardRef as ReactComponent };